import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const GstReturnsPage = lazy(() => import("@/pages/reports.gst.page"));

export const Route = createFileRoute("/reports/gst")({
  component: GstReturnsPage,
});
